enum KeyStatus {
  WAITING_KEY = "Attente clés",
  KEY_RECEIVED = "Clés réceptionnées",
  KEY_NOT_ENTERED = "Clés non renseignées",
}

export const keysStatusValues = [
  {
    color: "#641abf",
    name: KeyStatus.WAITING_KEY,
    hint: "Les clés vont être réceptionnées par le technicien Dwell.",
    notYet: "Sms de prise de rendez-vous pas encore envoyé",
  },
  {
    color: "#13bfa4",
    name: KeyStatus.KEY_RECEIVED,
    hint: "Les clés ont été réceptionnées par le technicien Dwell.",
    notYet: "Sms de rappel pour la prise rendez-vous pas encore envoyé",
  },
  {
    color: "#e90118",
    name: KeyStatus.KEY_NOT_ENTERED,
    hint: "La localisation des clés n’a pas été renseignée :",
    notYet:
      "Deuxième sms de rappel pour la prise rendez-vous pas encore envoyé",
  },
];

export const getKeyStatusValuesByStatus = (status: KeyStatus | string) => {
  return keysStatusValues.filter(
    (entry: { name: string }) => entry.name === status,
  )[0];
};
